function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h165v163H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M70 120c15.464 0 28-12.536 28-28S85.464 64 70 64v56z",
  fill: "#0278C7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M79 86l6 6.5-6 6.5",
  stroke: "#fff",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgExpandSidebarButton = function SvgExpandSidebarButton(props) {
  return React.createElement("svg", _extends({
    width: 165,
    height: 163,
    viewBox: "0 0 165 163",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml,%3Csvg width='165' height='163' viewBox='0 0 165 163' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='165' height='163' fill='none'/%3E %3Cpath d='M70 120C85.464 120 98 107.464 98 92C98 76.536 85.464 64 70 64V120Z' fill='%230278C7'/%3E %3Cpath d='M79 86L85 92.5L79 99' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";
export { SvgExpandSidebarButton as ReactComponent };